<app-page-header title="Bonded Slit Valve Door Seal Solution" subtitle="Reduces Particulation and Eases Installation."
  image="url(assets/site/images/general-header9.webp)">
</app-page-header>

<div id="content" class="container">
  <h2>Bonded Slit Valve Door Technology</h2>
  <p>The Bonded Slit Valve Door (BSV) increases the life expectancy and performance of the door's seal during semiconductor processing. Made from Greene Tweed's proprietary perfluoroelastomer compound, Chemraz® (or other customer requested elastomers), the seal is bonded to an aluminum/stainless steel door. Installation requires only removing and replacing a few bolts when replacing the complete BSV door assembly as opposed to cleaning the gland and installing a new o-ring. A bonded design minimizes abrasion, leading to less particulation in many processes compared to installation of a typical perfluoroelastomer o-ring. Therefore, a bonded-gate design can eliminate installation errors and variations, 
    reduce particle generation caused by o-ring movement in the gland, and provide up to a 10-fold increase in service life.</p>
  <h3>Benefits</h3>
  <ul class="responsive-grid-list">
    <li>Improved seal integrity</li>
    <li>Eliminate movement in gland and reduces wear</li>
    <li>Durable fluorocarbons withstand dynamic use </li>
    <li>Increased life expectancy of slit valve doors </li>
    <li>Lower contamination due to limited particle generation</li>
    <li>Eliminate potential leaks</li>
    <li>Optimal compression set for extended seal life</li>
    <li>Decreased replacement downtime </li>
    <li>Simplified installation</li>
    <li>Ensure proper seal orientation without twisting</li>
    <li>No traditional molded parting lines </li>
  </ul>
</div>